import { motion, useInView } from "framer-motion"
import { Link, graphql } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import Modal from "react-modal"
import ReactPlayer from "react-player"
import ImageOpt from "./ImageOpt"

const VideoWithContent = ({ module }) => {
  const [modalIsOpen, setIsOpen] = useState(false)

  function openModal(e) {
    if (e.target.tagName === "A") {
      e.preventDefault()
    }
    document.body.classList.add("modal-open")
    setIsOpen(true)
  }

  function closeModal() {
    document.body.classList.remove("modal-open")
    setIsOpen(false)
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "0",
      border: "0",
      borderRadius: "0",
      width: "100%",
      height: "100%",
      zIndex: "99999999",
      backgroundColor: "black",
    },
    overlay: {
      zIndex: "99999",
    },
  }

  const ref = useRef(null)
  const [hasPlayed, setHasPlayed] = useState(false)
  const isInView = useInView(ref)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }

  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  if (module.hideSection === "no") {
    return (
      <React.Fragment>
        <motion.section
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`video-with-content py-95 xlscreen:py-80 mdscreen:py-45 ${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="container-fluid-xl md2:!pl-0"
          >
            <div className="flex flex-wrap items-center">
              <motion.div
                variants={animFade}
                className="mdscreen2:w-full w-6/12 order-1 md2:order-1"
              >
                {module?.posterImage && (
                  <div className="img portrait">
                    <ImageOpt
                      imgData={module.posterImage.mediaItemUrl}
                      imgAlt={module.posterImage.title}
                      imgClass="mx-auto"
                      width={2000}
                      height={1000}
                      imgLoad="lazy"
                    />
                    {module?.video && (
                      <div className="play-main absolute top-50per left-50per translate-x-minus_50 translate-y-minus_50 z-10 opacity-60">
                        <button
                          className="h-[132px] w-[132px] xlscreen:h-100 xlscreen:w-100 mdscreen2:h-80 mdscreen2:w-80 rounded-100 border-[7px] mdscreen2:border-[5px] border-white-100 flex justify-center items-center"
                          type="button"
                        >
                          <img
                            src="../../images/play-icon.svg"
                            alt="play-icon"
                            width={64}
                            height={64}
                            loading="lazy"
                            className="!h-[60%] !w-[60%] !static translate-x-[5px] !object-contain !object-center"
                            onClick={e => {
                              openModal(e)
                            }}
                            onKeyDown={e => {
                              openModal(e)
                            }}
                            aria-hidden="true"
                          />
                        </button>
                      </div>
                    )}
                  </div>
                )}
                {module?.video && (
                  <Modal
                    isOpen={modalIsOpen}
                    style={customStyles}
                    onRequestClose={closeModal}
                    contentLabel="Video with content Modal"
                  >
                    <div className="video-modal-popup h-full">
                      <button
                        onClick={closeModal}
                        className="absolute right-60 top-60 bg-white-100 flex items-center justify-center w-[40px] h-[40px] rounded-100 z-999"
                      >
                        <img
                          src="../../images/close-icon.svg"
                          width={20}
                          height={20}
                          alt="alt"
                        />
                      </button>
                      <div className="flex flex-wrap items-center h-full">
                        <div className="lg:w-12/12 w-full h-full">
                          <div className="modal-video h-full">
                            <ReactPlayer
                              className="modal-banner-video !w-full !h-full"
                              loop={true}
                              playing={true}
                              controls={true}
                              muted={false}
                              url={module.video.url}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Modal>
                )}
              </motion.div>
              <div className="mdscreen2:w-full w-6/12 md2:pl-60 xl:!pl-80 mdscreen:!pt-30 order-2 md2:order-2 mdscreen2:pt-45">
                <div className="md2:max-w-[500px]">
                  {module?.heading && (
                    <motion.div
                      variants={animFade}
                      className="title title-grey uppercase"
                    >
                      <h3 className="font-500 tracking-0.04em">
                        {module.heading}
                      </h3>
                    </motion.div>
                  )}
                  {module?.description && (
                    <motion.div
                      variants={animFade}
                      className="content global-list pt-20"
                    >
                      {parse(module.description)}
                    </motion.div>
                  )}
                  {module?.button && (
                    <motion.div
                      variants={animFade}
                      className="flex flex-wrap gap-40 xlscreen:gap-25 pt-20 md:pt-30"
                    >
                      <Link
                        to={"#"}
                        className="btn btn-grey"
                        onClick={e => openModal(e)}
                      >
                        {module.button.title}
                      </Link>
                    </motion.div>
                  )}
                  {module?.video && (
                    <Modal
                      isOpen={modalIsOpen}
                      style={customStyles}
                      onRequestClose={closeModal}
                      contentLabel="Example Modal"
                    >
                      <div className="video-modal-popup h-full">
                        <button
                          onClick={closeModal}
                          className="absolute right-60 top-60 bg-white-100 flex items-center justify-center w-[40px] h-[40px] rounded-100 z-9999"
                        >
                          <img
                            src="/images/close-icon.svg"
                            width={20}
                            height={20}
                            alt="alt"
                          />
                        </button>
                        <div className="flex flex-wrap items-center h-full">
                          <div className="lg:w-12/12 w-full h-full">
                            <div className="modal-video h-full">
                              <ReactPlayer
                                className="modal-banner-video !w-full !h-full"
                                loop={true}
                                playing={true}
                                controls={true}
                                muted={false}
                                url={module.video.url}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </Modal>
                  )}
                </div>
              </div>
            </div>
          </motion.div>
        </motion.section>
      </React.Fragment>
    )
  }
}

export default VideoWithContent
export const PageVideoWithContentFragment = graphql`
  fragment PageVideoWithContentFragment on WpPage_Pagecontent_PageContent_VideoWithContent {
    extraClass
    extraId
    hideSection
    description
    button {
      target
      url
      title
    }
    downloadButton {
      target
      title
      url
    }
    heading
    sectionStyle
    video {
      target
      title
      url
    }
    videoPosition
    posterImage {
      altText
      mediaItemUrl
      title
    }
  }
`